import { render, staticRenderFns } from "./StatsRevenuePerEmployee.vue?vue&type=template&id=67a638b8&"
import script from "./StatsRevenuePerEmployee.vue?vue&type=script&lang=js&"
export * from "./StatsRevenuePerEmployee.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/workspace/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('67a638b8')) {
      api.createRecord('67a638b8', component.options)
    } else {
      api.reload('67a638b8', component.options)
    }
    module.hot.accept("./StatsRevenuePerEmployee.vue?vue&type=template&id=67a638b8&", function () {
      api.rerender('67a638b8', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "public/js/src/app/components/purchase-activity/reports/StatsRevenuePerEmployee.vue"
export default component.exports